var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardDispenser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Card_Dispenser"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Card_Dispenser",
    "data-name": "Card Dispenser",
    clipPath: "url(#clip-Card_Dispenser)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "atm_372793",
    transform: "translate(-44.652 99.891) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1035",
    "data-name": "Group 1035",
    transform: "translate(0 55.652)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_390",
    "data-name": "Path 390",
    d: "M90.119,55.652H9.772A9.783,9.783,0,0,0,0,65.424V78.453a9.783,9.783,0,0,0,9.772,9.772h9.772v35.831a9.783,9.783,0,0,0,9.772,9.772H70.575a9.783,9.783,0,0,0,9.772-9.772V88.225h9.772a9.783,9.783,0,0,0,9.772-9.772V65.424A9.783,9.783,0,0,0,90.119,55.652ZM39.088,117.541a3.257,3.257,0,0,1-6.515,0v-6.515a3.257,3.257,0,1,1,6.515,0Zm0-19.544a3.257,3.257,0,0,1-6.515,0V91.483a3.257,3.257,0,0,1,6.515,0ZM60.8,127.313H54.289V75.2H60.8Zm32.573-48.86a3.261,3.261,0,0,1-3.257,3.257H80.347V75.2H83.6a3.257,3.257,0,1,0,0-6.515H16.287a3.257,3.257,0,1,0,0,6.515h3.257v6.515H9.772a3.261,3.261,0,0,1-3.257-3.257V65.424a3.261,3.261,0,0,1,3.257-3.257H90.119a3.261,3.261,0,0,1,3.257,3.257Z",
    transform: "translate(0 -55.652)",
    fill: "#e8eaf0"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDispenser);
export default __webpack_public_path__ + "static/media/card-dispenser.dbc6afc4df92e986f4f103141e34ebd5.svg";
export { ForwardRef as ReactComponent };